import {ADMIN_CHECK, AUTH_USER_SET} from "../constants/ActionTypes";

const INITIAL_STATE = {
    authUser: null,
};

const applySetAuthUser = (state, action) => ({
    ...state,
    authUser: action.authUser
});

const applySetAdmin = (state, action) => ({
    ...state,
    isAdmin : action.payload.isAdmin
});

function sessionReducer(state = INITIAL_STATE, action) {
    switch(action.type) {
        case AUTH_USER_SET : {
            return applySetAuthUser(state, action);
        }
        case ADMIN_CHECK : {
            return applySetAdmin(state, action);
        }
        default : return state;
    }
}

export default sessionReducer;


// WEBPACK FOOTER //
// ./src/reducers/session.js